import React, {Component} from 'react';
import {Button, Link, Tooltip} from "@mui/material";

import Loading from "../../../component/loading/Loading";
import DynamicSearchButton from "../component/DynamicSearchButton";
import SelectList from "../../../component/input/SelectList";
import TextInput from "../../../component/input/TextInput";
import PaginationComponent from "../../../component/table/Pagination";

import * as stringUtil from '../../../util/stringUtil';
import * as apiUtil from '../../../util/apiUtil';
import * as dateUtil from '../../../util/dateUtil';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as sentMessageAction from "../store/sentMessage";

import "./SentMessageSearchEngine.css";
import SingleButton from "../../../component/button/SingleButton";

const sortList = [
    { label: '최신순', value: 'desc' },
    { label: '오래된순', value: 'asc' },
];
const stateList = [
    { label: '등록',      value: 'REG'      },
    { label: '검수 요청', value: 'INSP_REQ' },
    { label: '검수 완료', value: 'INSP_APR' },
    { label: '발송 요청', value: 'WAIT'     },
    { label: '발송 대기', value: 'STNB'     },
    { label: '발송 반려', value: 'REJ'      },
    { label: '발송 중',   value: 'PROC'     },
    { label: '발송 완료', value: 'CMPL'     },
    { label: '발송 취소', value: 'CNCL'     },
];

class SentListContainer extends Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.setValue = this.setValue.bind(this);

        this.handleSearch = this.handleSearch.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSingleCheck = this.handleSingleCheck.bind(this);
        this.handleAllCheck = this.handleAllCheck.bind(this);
        this.handleDynamicValues = this.handleDynamicValues.bind(this);
        this.validSearchInfo = this.validSearchInfo.bind(this);
        this.saveSearchInfo = this.saveSearchInfo.bind(this);

        this.ajaxGetSentMessageList = this.ajaxGetSentMessageList.bind(this);
        this.ajaxDownloadExcel = this.ajaxDownloadExcel.bind(this);

        this.ajaxInspectGounCampaign = this.ajaxInspectGounCampaign.bind(this);

        this.state = {
            loading: false,
            checkItems: [],

            dynamicName: '',
            dynamicSort: '',

            preInputStartDate: '',
            preInputEndDate: '',
            preSelectSortBy: '',
            preInputMessageName: '',
            preSelectState: '',
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.page !== nextProps.page
            || this.props.size !== nextProps.size
            || this.props.inputStartDate !== nextProps.inputStartDate
            || this.props.inputEndDate !== nextProps.inputEndDate
            || this.props.selectSortBy !== nextProps.selectSortBy
            || this.props.inputMessageName !== nextProps.inputMessageName
            || this.props.selectState !== nextProps.selectState
            || this.props.total !== nextProps.total
            || this.props.messageList !== nextProps.messageList

            || this.state.loading !== nextState.loading
            || this.state.checkItems !== nextState.checkItems
            || this.state.dynamicName !== nextState.dynamicName
            || this.state.dynamicSort !== nextState.dynamicSort
            || this.state.preInputStartDate !== nextState.preInputStartDate
            || this.state.preInputEndDate !== nextState.preInputEndDate
            || this.state.preSelectSortBy !== nextState.preSelectSortBy
            || this.state.preInputMessageName !== nextState.preInputMessageName
            || this.state.preSelectState !== nextState.preSelectState
        )
    }
    componentDidMount() {
        // <24.09.19> QA 피드백 조회 버튼을 눌러야 리스트 확인 가능
        this.ajaxGetSentMessageList();
    }

    /* setter */
    setLoading(loading) {
        this.setState({ loading: loading });
    }
    async setValue(id, value) {
        const { SentMessageAction } = this.props;

        switch (id) {
            case "selectSortBy" :
                await SentMessageAction.setSelectSortBy(value);
                await SentMessageAction.setPage(1);
                this.ajaxGetSentMessageList();
                break;
            case "selectState":
                await SentMessageAction.setSelectState(value);
                await SentMessageAction.setPage(1);
                this.ajaxGetSentMessageList();
                break;
            case "inputMessageName":
                SentMessageAction.setInputMessageName(value);
                break;
            case "inputStartDate":
                SentMessageAction.setInputStartDate(value);
                break;
            case "inputEndDate":
                SentMessageAction.setInputEndDate(value);
                break;
            default:
                break;
        }

    }

    // <24.09.19> QA 피드백 이전 검색 조건과 동일하면 피드백
    validSearchInfo() {
        // 이전 검색 조건이 맞는지
        const { inputStartDate, inputEndDate, selectSortBy, inputMessageName, selectState } = this.props;
        const { preInputStartDate, preInputEndDate, preSelectSortBy, preInputMessageName, preSelectState } = this.state;
        return (inputStartDate === preInputStartDate) && (inputEndDate === preInputEndDate) && (selectSortBy === preSelectSortBy) && (inputMessageName === preInputMessageName) && (selectState === preSelectState);
    }

    saveSearchInfo() {
        // 이전 검색 조건 state에 저장
        const { inputStartDate, inputEndDate, selectSortBy, inputMessageName, selectState } = this.props;
        this.setState({ preInputStartDate: inputStartDate, preInputEndDate: inputEndDate, preSelectSortBy: selectSortBy, preInputMessageName: inputMessageName, preSelectState: selectState });
    }

    /* handlers */
    async handleSearch() {
        const { SentMessageAction } = this.props;
        const { ajaxGetSentMessageList, validSearchInfo, saveSearchInfo } = this;
        if(validSearchInfo()) {
            alert("이전 검색 조건과 동일 합니다!");
            return;
        }
        await SentMessageAction.setPage(1);
        ajaxGetSentMessageList();
        saveSearchInfo();
    }
    async handlePageChange(event, value) {
        const { SentMessageAction } = this.props;
        const { ajaxGetSentMessageList } = this;

        await SentMessageAction.setPage(value);
        this.setState({ checkItems: [] });
        ajaxGetSentMessageList();
    }
    handleSingleCheck(checked, uid) {
        if (checked) {
            this.setState({ checkItems: [...this.state.checkItems, uid] });
        } else {
            this.setState({ checkItems: this.state.checkItems.filter((message) => message !== uid) });
        }
    };
    handleAllCheck (checked) {
        const { messageList } = this.props;

        if(checked) {
            const idArray = [];
            messageList.forEach((message) => idArray.push(message.uid));
            this.setState({ checkItems: idArray })
        }
        else {
            this.setState({ checkItems: [] });
        }
    }

    handleDynamicValues(buttonName, dynamicSort, type) {
        switch(type) {
            case "firstClick":
                this.setState({ dynamicName: buttonName, dynamicSort: dynamicSort }, this.ajaxGetSentMessageList)
                break;
            case "changeSort":
                this.setState({dynamicSort: dynamicSort}, this.ajaxGetSentMessageList)
                break;
            default:
                break;
        }// end switch
    }

    /* ajax request methods */
    ajaxGetSentMessageList() {
        const { page, size, inputStartDate, inputEndDate, selectSortBy, inputMessageName, selectState } = this.props;
        const { dynamicName, dynamicSort } = this.state;
        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/list",
            method: apiUtil.requestMethod.POST,
            data: {
                page: page,
                size: size,
                startDate: inputStartDate + " 00:00:00",
                endDate: inputEndDate + " 23:59:59",
                sort: selectSortBy,
                messageName: inputMessageName,
                state: selectState,
                dynamicName: dynamicName,
                dynamicSort: dynamicSort
            },
            success: (result) => {
                const { SentMessageAction } = this.props;
                SentMessageAction.setMessageList(result.content);
                SentMessageAction.setTotal(result.total);
                if (this.props.inputEndDate === "9999-12-31") {
                    const today = dateUtil.dateToStr(new Date());
                    const maxSndDate = result.content?.length > 0
                        ? (result.content[0].sendDate ?? "").split(" ")[0] || today
                        : today;
                    SentMessageAction.setInputEndDate(maxSndDate < today ? today : maxSndDate);
                }
            }
        })
    }
    ajaxDownloadExcel = () => {
        const { inputStartDate, inputEndDate, selectSortBy, inputMessageName, selectState } = this.props;
        const { checkItems } = this.state;

        apiUtil.fileDownloadRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/list/download",
            method: apiUtil.requestMethod.POST,
            data: {
                startDate: inputStartDate + " 00:00:00",
                endDate: inputEndDate + " 23:59:59",
                sort: selectSortBy,
                messageName: inputMessageName,
                state: selectState,
                checkItems: checkItems,
            },
            success: (blob, filename) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        })
    }

    ajaxInspectGounCampaign(campaignUid) {
        if (! window.confirm(
            "검수 요청 버튼을 누르면 취소가 불가능합니다." +
            "\n검수가 완료된 후 발송 취소 버튼을 누르지 않으면 자동으로 발송 희망 일자에 맞추어 발송이 진행됩니다." +
            "\n검수 요청 진행하시겠습니까?"
        )) {
            return;
        }

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/message/ai/goun/inspect/" + campaignUid,
            method: apiUtil.requestMethod.POST,
            success: async (result) => {
                alert("검수 요청이 완료되었습니다.\n검수는 약 3~5일 소요되며, SKT 메시지 정책에 따라 많은 내용 변경이 있을 수 있습니다.");
                window.location.reload();
            }
        });
    }


    render() {
        const { loading, checkItems, dynamicName, dynamicSort } = this.state;

        const { inputStartDate, inputEndDate, selectSortBy, selectState, inputMessageName } = this.props;
        const { setValue, ajaxGetSentMessageList, handleSearch, ajaxDownloadExcel, handleSingleCheck, handleAllCheck, handleDynamicValues } = this;

        const { page, size, total, messageList } = this.props;
        const { handlePageChange } = this;

        const { ajaxInspectGounCampaign } = this;

        return (
            <div className='container-xxl'>
                <style>{`
                    .sent-list-table .btn-sort {
                        width: 100%;
                        padding-right: 20px;
                    }
                `}</style>
                <Loading loading={loading}/>
                <h2 className='fs-4'>발송 메시지</h2>
                <div className='info-content-item shadow'>
                    <h5 className=' d-flex align-items-center'>
                        <span className="material-symbols-outlined text-primary fs-4 pe-2 fw-bold">report</span>
                        <span>발송 메시지 확인</span>
                    </h5>
                    <ol className='fs-6 mb-0 fw-normal fs-4 ps-3 ps-sm-5 '>
                        <li>추천 메시지, 셀프 메시지를 이용해 발송 요청한 메시지들을 확인할 수 있습니다.</li>
                        <li>메시지 명을 클릭하면 상세 정보를 확인할 수 있습니다.</li>
                        <li>발송 완료된 메시지는 메시지 별 통계를 확인할 수 있습니다.</li>
                    </ol>
                </div>
                <div className='card'>
                    <div className='card-body'>
                        <div className='search-box bg-light p-lg-4 p-3'>
                            <div className='row pb-2 align-items-center'>
                                <div className='col-lg-auto'>
                                    <Tooltip title={
                                        <div>
                                            <p className={"mb-0"}>발송 일시 기준으로 조회됩니다.</p>
                                        </div>
                                    }>
                                        <div className='d-inline-flex align-items-center mb-2 pointer'>
                                            <h5 className='d-inline-block mb-0 h-fix'>기간 설정</h5>
                                            <span className="material-symbols-rounded fs-5 ps-2 text-primary">info</span>
                                        </div>
                                    </Tooltip>
                                </div>

                                <div className='col-lg-auto d-flex flex-sm-row flex-column  text-center'>
                                    <SelectList
                                        id="selectSortBy"
                                        className="form-select d-inline me-0 me-sm-2"
                                        list={sortList}
                                        value={selectSortBy}
                                        onChange={setValue}
                                        disableDefault={true}
                                    />
                                    <TextInput
                                        className="form-control d-inline"
                                        type="date"
                                        id="inputStartDate"
                                        value={inputStartDate}
                                        onChange={setValue}
                                    />
                                    <span className='px-2'>~</span>
                                    <TextInput
                                        className="form-control d-inline"
                                        type="date"
                                        id="inputEndDate"
                                        value={inputEndDate}
                                        onChange={setValue}
                                    />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <div className='row align-items-center'>
                                        <div className='col-lg-auto'>
                                            <h5 className=' d-inline-flex col-lg-auto  mb-lg-0'>메시지 명칭</h5>
                                        </div>
                                        <div className='col-lg-auto'>
                                            <TextInput
                                                onKeyDown={ajaxGetSentMessageList}
                                                className="form-control"
                                                type="text"
                                                id="inputMessageName"
                                                value={inputMessageName}
                                                onChange={setValue}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6'>
                                    <div className='row align-items-center'>
                                        <div className='col-lg-auto'>
                                            <h5 className=' d-inline-flex mb-lg-0'>메시지 상태</h5>
                                        </div>
                                        <div className='col-lg-auto'>
                                            <SelectList
                                                id="selectState"
                                                className="form-select"
                                                list={stateList}
                                                value={selectState}
                                                onChange={setValue}
                                                defaultLabel="전체"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="d-flex justify-content-center">
                                <button className="btn btn-primary me-2 d-flex align-items-center" onClick={handleSearch}>조회 <span className="material-symbols-rounded fs-5 ms-1">search</span></button>
                                <button className="btn btn-success d-inline-flex align-items-center" onClick={ajaxDownloadExcel}>내역받기 <span className="material-symbols-rounded fs-5">file_save</span></button>
                            </div>
                        </div>
                        <div className="pt-3">
                            <div className="row py-2">
                                <div className="col-lg-6">총 {total} 건</div>
                                <small className="col-lg-6 text-end ">* 리스트 선택 시 메시지 별 상세 내용이 확인 가능합니다.</small>
                            </div>
                            <div className='table-responsive'>
                                <table className="table table-bordered table-hover fs-6 sent-list-table" style={{tableLayout:'fixed', minWidth:'1200px'}}>
                                    <colgroup>
                                        <col style={{width:'40px'}} />
                                        <col style={{width:'300px'}}/>
                                        <col style={{width:'110px'}} />
                                        <col style={{width:'90px'}} />
                                        <col style={{width:'110px'}} />
                                        <col style={{width:'130px'}} />
                                        <col style={{width:'90px'}} />
                                        <col style={{width:'90px'}} />
                                        <col style={{width:'90px'}} />
                                        <col style={{width:'90px'}} />
                                        <col style={{width:'90px'}} />
                                        {/*<col style={{width:'130px'}} />*/}
                                    </colgroup>
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-center">
                                                <input
                                                    className='form-check-input'
                                                    type="checkbox"
                                                    name="select-all"
                                                    onChange={(e)=>handleAllCheck(e.target.checked)}
                                                    checked={messageList.length !== 0 && checkItems.length === messageList.length}
                                                />
                                            </th>
                                            <th>
                                                <DynamicSearchButton
                                                        colName={"메시지명"}
                                                        buttonName="name"
                                                        dynamicName={dynamicName}
                                                        dynamicSort={dynamicSort}
                                                        handleDynamicValues={handleDynamicValues}
                                            /></th>
                                            <th className="text-center">메시지 상태</th>
                                            <th className="text-center">요금제</th>
                                            <th className="text-end"><DynamicSearchButton
                                                colName={"사용 포인트"}
                                                buttonName="budget"
                                                dynamicName={dynamicName}
                                                dynamicSort={dynamicSort}
                                                handleDynamicValues={handleDynamicValues}
                                            /></th>
                                            <th className="text-center"><DynamicSearchButton
                                                colName={"발송 일시"}
                                                buttonName="ats_snd_start_date"
                                                dynamicName={dynamicName}
                                                dynamicSort={dynamicSort}
                                                handleDynamicValues={handleDynamicValues}
                                            /></th>
                                            <th className="text-end"><DynamicSearchButton
                                                colName={"발송수"}
                                                buttonName="sendCnt"
                                                dynamicName={dynamicName}
                                                dynamicSort={dynamicSort}
                                                handleDynamicValues={handleDynamicValues}
                                            /></th>
                                            <th className="text-center">읽음수</th>
                                            <th className="text-center">읽음률</th>
                                            <th className="text-end"><DynamicSearchButton
                                                colName={"반응수"}
                                                buttonName="recv_cnt"
                                                dynamicName={dynamicName}
                                                dynamicSort={dynamicSort}
                                                handleDynamicValues={handleDynamicValues}
                                            /></th>
                                            <th className="text-end"><DynamicSearchButton
                                                colName={"반응률"}
                                                buttonName="recv_rate"
                                                dynamicName={dynamicName}
                                                dynamicSort={dynamicSort}
                                                handleDynamicValues={handleDynamicValues}
                                            /></th>
                                            {/*<th className="text-center">등록 일시</th>*/}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            total === 0 &&
                                            <tr>
                                                <td colSpan="11" className="text-center">조건 설정 후 조회 버튼을 클릭해주세요.</td>
                                            </tr>
                                        }
                                        {
                                            messageList.map((message, idx) => (
                                                <tr key={idx}>
                                                    <td className="text-center">
                                                        <input
                                                            className='form-check-input'
                                                            type="checkbox"
                                                            name={`select-${message.uid}`}
                                                            onChange={(e) => handleSingleCheck(e.target.checked, message.uid)}
                                                            checked={checkItems.includes(message.uid)}
                                                        />
                                                    </td>
                                                    <td className='td-link' style={{overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}><Link href={"/sent/detail/" + message.uid}>{message.name}</Link></td>
                                                    <td className="text-center">
                                                        {message.msgState}<br/>
                                                        {
                                                            message.state === 0 &&
                                                            <SingleButton
                                                                className="btn btn-sm btn-primary"
                                                                label="검수요청"
                                                                handleClick={() => ajaxInspectGounCampaign(message.uid)}
                                                            />
                                                        }
                                                    </td>
                                                    <td className="text-center">{message.packageId === null || message.packageId === undefined ? '일반' : '패키지'}</td>
                                                    <td className="text-end">{stringUtil.formatNumber(message.budget)}</td>
                                                    <td className="text-center" style={{fontSize:'0.875em'}}>{message.sendDate && <>{message.sendDate.split(' ')[0]}<br/>{message.sendDate.split(' ')[1]}</>}</td>
                                                    <td className="text-end">{stringUtil.formatNumber(message.sendCnt)}</td>
                                                    <td className="text-end">{stringUtil.formatNumber(message.readCnt)}</td>
                                                    <td className="text-end">{message.readRate != null ? `${message.readRate}%` : ''}</td>
                                                    <td className="text-end">{stringUtil.formatNumber(message.recvCnt)}</td>
                                                    <td className="text-end">{message.recvRate}%</td>
                                                    {/*<td className="text-center" style={{fontSize:'0.875em'}}>{message.regDate && <>{message.regDate.split(' ')[0]}<br/>{message.regDate.split(' ')[1]}</>}</td>*/}
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <PaginationComponent page={page} total={total} sizePerPage={size} handleChange={handlePageChange}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    (state) => ({
        page: state.sentMessage.get('page'),
        size: state.sentMessage.get('size'),
        inputStartDate: state.sentMessage.get('inputStartDate'),
        inputEndDate: state.sentMessage.get('inputEndDate'),
        selectSortBy: state.sentMessage.get('selectSortBy'),
        inputMessageName: state.sentMessage.get('inputMessageName'),
        selectState: state.sentMessage.get('selectState'),

        total: state.sentMessage.get('total'),
        messageList: state.sentMessage.get('messageList'),
    }),
    (dispatch) => ({
        SentMessageAction: bindActionCreators(sentMessageAction, dispatch),
    })
)(SentListContainer);
